module.exports = "build/assets/guns.77fbee64.png";